import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";

import { environment } from "../../../../environments/environment";
import { ProjectSectionConfig, SectionItem } from "../domains/project-section-config";

@Injectable({ providedIn: "root" })
export class ProjectSectionConfigService {
  private http = inject(HttpClient);
  private url = environment.apiUrl + "/project-section-configs";

  getByProject(projectId: string): Observable<ProjectSectionConfig | null> {
    return this.http.get<ProjectSectionConfig>(`${this.url}?project_id=${projectId}`).pipe(catchError(() => of(null)));
  }

  save(projectId: string, sectionOrder: SectionItem[]): Observable<ProjectSectionConfig> {
    return this.http.put<ProjectSectionConfig>(this.url, {
      project_id: projectId,
      section_order: sectionOrder,
    });
  }
}
